// /* global cv */
// import React, { useRef, useState, useEffect } from "react";
// import Webcam from "react-webcam";
// import axios from "axios";
// import { toast } from "react-toastify";

// const OMRScanner = ({ examId, questions, studentId, classId, penalty, setSelectedExam, onResult }) => {

// const webcamRef = useRef(null);
// const canvasRef = useRef(null);

// const [cameraReady,setCameraReady] = useState(false);
// const [cvReady,setCvReady] = useState(false);
// const [loading,setLoading] = useState(false);
// const [sheetDetected,setSheetDetected] = useState(false);
//   const biggestContourRef = useRef(null);
//   console.log(questions);

// useEffect(()=>{

// const check = setInterval(()=>{

// if(window.cv){
// setCvReady(true);
// clearInterval(check);
// }

// },500);

// },[]);

// /* LIVE PAPER DETECTION */

// // useEffect(()=>{

// // if(!cameraReady || !cvReady) return;

// // const interval = setInterval(()=>{

// // const video = webcamRef.current.video;
// // const canvas = canvasRef.current;

// // if(!video || !canvas) return;

// // const ctx = canvas.getContext("2d");

// // canvas.width = video.videoWidth;
// // canvas.height = video.videoHeight;

// // ctx.drawImage(video,0,0);

// // let src = cv.imread(canvas);
// // let gray = new cv.Mat();
// // let blur = new cv.Mat();
// // let edges = new cv.Mat();

// //    cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);
// //       cv.GaussianBlur(gray, blur, new cv.Size(5, 5), 0);
// //       cv.Canny(blur, edges, 75, 200);


// //   let contours = new cv.MatVector();
// //       let hierarchy = new cv.Mat();

// // cv.findContours(edges,contours,hierarchy,cv.RETR_EXTERNAL,cv.CHAIN_APPROX_SIMPLE);

// //  let biggest = null;
// //       let maxArea = 0;

// // for (let i = 0; i < contours.size(); i++) {
// //         let cnt = contours.get(i);
// //         let area = cv.contourArea(cnt);

// //         if (area > maxArea) {
// //           let peri = cv.arcLength(cnt, true);
// //           let approx = new cv.Mat();

// //           cv.approxPolyDP(cnt, approx, 0.02 * peri, true);

// //           if (approx.rows === 4) {
// //             biggest = approx;
// //             maxArea = area;
// //           }
// //         }
// //       }

// //       const videoArea = video.videoWidth * video.videoHeight;


// //       if (biggest && maxArea > 0.4 * videoArea) {
// //         biggestContourRef.current = biggest;
// //         setSheetDetected(true);

// //         // draw corners
// //         for (let i = 0; i < 4; i++) {
// //           let point = biggest.intPtr(i);
// //           ctx.beginPath();
// //           ctx.arc(point[0], point[1], 6, 0, 2 * Math.PI);
// //           ctx.fillStyle = "lime";
// //           ctx.fill();
// //         }
// //       } else {
// //         setSheetDetected(false);
// //       }

// //       src.delete();
// //       gray.delete();
// //       blur.delete();
// //       edges.delete();
// //       contours.delete();
// //       hierarchy.delete();
// //     }, 400);

// //     return () => clearInterval(interval);
// //   }, [cameraReady, cvReady]);


// // working effect
// useEffect(()=>{

// if(!cameraReady || !cvReady) return;

// const interval = setInterval(()=>{

// const video = webcamRef.current.video;
// const canvas = canvasRef.current;

// if(!video || !canvas) return;

// const ctx = canvas.getContext("2d");

// canvas.width = video.videoWidth;
// canvas.height = video.videoHeight;

// ctx.drawImage(video,0,0);

// let src = cv.imread(canvas);
// let gray = new cv.Mat();
// let blur = new cv.Mat();
// let edges = new cv.Mat();
// let closed = new cv.Mat();

// cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);
// cv.GaussianBlur(gray, blur, new cv.Size(5, 5), 0);

// // ✅ edge detection
// cv.Canny(blur, edges, 50, 150);

// // ✅ FIX: close gaps in edges
// let kernel = cv.Mat.ones(5, 5, cv.CV_8U);
// cv.morphologyEx(edges, closed, cv.MORPH_CLOSE, kernel);
// kernel.delete();

// let contours = new cv.MatVector();
// let hierarchy = new cv.Mat();

// // ✅ FIX: use LIST instead of EXTERNAL
// cv.findContours(closed, contours, hierarchy, cv.RETR_LIST, cv.CHAIN_APPROX_SIMPLE);

// let biggest = null;
// let maxArea = 0;

// for (let i = 0; i < contours.size(); i++) {
//   let cnt = contours.get(i);
//   let area = cv.contourArea(cnt);

//   if (area < 1000) continue; // ignore noise

//   let peri = cv.arcLength(cnt, true);
//   let approx = new cv.Mat();

//   cv.approxPolyDP(cnt, approx, 0.02 * peri, true);

//   if (approx.rows === 4 && area > maxArea) {
//     biggest = approx;
//     maxArea = area;
//   } else {
//     approx.delete();
//   }
// }

// const videoArea = video.videoWidth * video.videoHeight;

// // ✅ FIX: reduce threshold (IMPORTANT)
// if (biggest && maxArea > 0.2 * videoArea) {

//   biggestContourRef.current = biggest;
//   setSheetDetected(true);

//   // draw corners
//   for (let i = 0; i < 4; i++) {
//     let point = biggest.intPtr(i);
//     ctx.beginPath();
//     ctx.arc(point[0], point[1], 6, 0, 2 * Math.PI);
//     ctx.fillStyle = "lime";
//     ctx.fill();
//   }

// } else {
//   setSheetDetected(false);
// }

// // 🧪 DEBUG (optional)
// // cv.imshow(canvasRef.current, closed);

// src.delete();
// gray.delete();
// blur.delete();
// edges.delete();
// closed.delete();
// contours.delete();
// hierarchy.delete();

// }, 400);

// return () => clearInterval(interval);

// }, [cameraReady, cvReady]);




//    const sortPoints = (pts) => {
//     pts = pts.sort((a, b) => a.y - b.y);

//     let top = pts.slice(0, 2).sort((a, b) => a.x - b.x);
//     let bottom = pts.slice(2, 4).sort((a, b) => a.x - b.x);

//     return [top[0], top[1], bottom[1], bottom[0]];
//   };

// const capture = async ()=>{

// if(!sheetDetected || !biggestContourRef.current){
// toast.error("Align the sheet properly");
// return;
// }

// // const imageSrc = webcamRef.current.getScreenshot();

// // const blob = await fetch(imageSrc).then(r=>r.blob());



// try{

// setLoading(true);

//    const canvas = canvasRef.current;
//       let src = cv.imread(canvas);
//       let dst = new cv.Mat();

//       let pts = [];

//       for (let i = 0; i < 4; i++) {
//         let p = biggestContourRef.current.intPtr(i);
//         pts.push({ x: p[0], y: p[1] });
//       }

//       let ordered = sortPoints(pts);

//       let srcTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         ordered[0].x, ordered[0].y,
//         ordered[1].x, ordered[1].y,
//         ordered[2].x, ordered[2].y,
//         ordered[3].x, ordered[3].y
//       ]);

//       let width = 800;
//       let height = 1200;

//       let dstTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         0, 0,
//         width, 0,
//         width, height,
//         0, height
//       ]);

//       let M = cv.getPerspectiveTransform(srcTri, dstTri);
//       cv.warpPerspective(src, dst, M, new cv.Size(width, height));

//       // show warped image
//       cv.imshow(canvasRef.current, dst);

//       const imageSrc = canvasRef.current.toDataURL("image/jpeg", 0.95);
//       const blob = await fetch(imageSrc).then(r => r.blob());

// const formData = new FormData();

// formData.append("image",blob,"omr.jpg");
// formData.append("exam_id",examId);
// formData.append("student_id",studentId);
// formData.append("class_id",classId);
// formData.append("questions",JSON.stringify(questions));
// formData.append("penalty",penalty);

// const res = await axios.post(
// "https://api.scannscore.com/scan_omr",
// formData
// );


// setLoading(false);

// onResult(res.data);
// if(res.status == 200){
// toast.success("OMR scanned successfully");
// } else if(res.status == 400){
// toast.success("OMR Already Scanned. Check Result.");
// }

//    src.delete();
//       dst.delete();
//       srcTri.delete();
//       dstTri.delete();
//       M.delete();


// }catch(err){

// setLoading(false);
// toast.error("Scan failed");

// }

// };

// return (

// <div style={{position:"relative"}}>

// <Webcam
// ref={webcamRef}
// audio={false}
// screenshotFormat="image/jpeg"
// screenshotQuality={0.95}
// forceScreenshotSourceSize={true}
// videoConstraints={{facingMode:"environment"}}
// onUserMedia={()=>setCameraReady(true)}
// style={{
// width:"100%",
// height:"500px",
// objectFit:"cover",
// borderRadius:"10px"
// }}
// />

// <canvas
// ref={canvasRef}
// style={{
// position:"absolute",
// top:0,
// left:0,
// width:"100%",
// height:"500px"
// }}
// />

// <button
// className="btn btn-success mt-3 w-100"
// disabled={!cameraReady || loading}
// onClick={capture}

// >

// {loading ? "Scanning..." : "Capture OMR"} </button>

// <button
// className="btn btn-secondary mt-3 w-100"
// onClick={()=>setSelectedExam("")}

// >

// Go Back </button>

// </div>

// );

// };

// export default OMRScanner;



// import React, { useRef, useState, useEffect } from "react";
// import Webcam from "react-webcam";
// import axios from "axios";
// import { toast } from "react-toastify";

// const OMRScanner = ({ examId, questions, studentId, classId, penalty, setSelectedExam, onResult }) => {

// const webcamRef = useRef(null);
// const canvasRef = useRef(null);

// const [cameraReady,setCameraReady] = useState(false);
// const [cvReady,setCvReady] = useState(false);
// const [loading,setLoading] = useState(false);
// const [sheetDetected,setSheetDetected] = useState(false);
//   const biggestContourRef = useRef(null);
//   console.log(questions);

// useEffect(()=>{

// const check = setInterval(()=>{

// if(window.cv){
// setCvReady(true);
// clearInterval(check);
// }

// },500);

// },[]);

// /* LIVE PAPER DETECTION */

// // useEffect(()=>{

// // if(!cameraReady || !cvReady) return;

// // const interval = setInterval(()=>{

// // const video = webcamRef.current.video;
// // const canvas = canvasRef.current;

// // if(!video || !canvas) return;

// // const ctx = canvas.getContext("2d");

// // canvas.width = video.videoWidth;
// // canvas.height = video.videoHeight;

// // ctx.drawImage(video,0,0);

// // let src = cv.imread(canvas);
// // let gray = new cv.Mat();
// // let blur = new cv.Mat();
// // let edges = new cv.Mat();

// //    cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);
// //       cv.GaussianBlur(gray, blur, new cv.Size(5, 5), 0);
// //       cv.Canny(blur, edges, 75, 200);


// //   let contours = new cv.MatVector();
// //       let hierarchy = new cv.Mat();

// // cv.findContours(edges,contours,hierarchy,cv.RETR_EXTERNAL,cv.CHAIN_APPROX_SIMPLE);

// //  let biggest = null;
// //       let maxArea = 0;

// // for (let i = 0; i < contours.size(); i++) {
// //         let cnt = contours.get(i);
// //         let area = cv.contourArea(cnt);

// //         if (area > maxArea) {
// //           let peri = cv.arcLength(cnt, true);
// //           let approx = new cv.Mat();

// //           cv.approxPolyDP(cnt, approx, 0.02 * peri, true);

// //           if (approx.rows === 4) {
// //             biggest = approx;
// //             maxArea = area;
// //           }
// //         }
// //       }

// //       const videoArea = video.videoWidth * video.videoHeight;


// //       if (biggest && maxArea > 0.4 * videoArea) {
// //         biggestContourRef.current = biggest;
// //         setSheetDetected(true);

// //         // draw corners
// //         for (let i = 0; i < 4; i++) {
// //           let point = biggest.intPtr(i);
// //           ctx.beginPath();
// //           ctx.arc(point[0], point[1], 6, 0, 2 * Math.PI);
// //           ctx.fillStyle = "lime";
// //           ctx.fill();
// //         }
// //       } else {
// //         setSheetDetected(false);
// //       }

// //       src.delete();
// //       gray.delete();
// //       blur.delete();
// //       edges.delete();
// //       contours.delete();
// //       hierarchy.delete();
// //     }, 400);

// //     return () => clearInterval(interval);
// //   }, [cameraReady, cvReady]);


// // working effect
// useEffect(()=>{

// if(!cameraReady || !cvReady) return;

// const interval = setInterval(()=>{

// const video = webcamRef.current.video;
// const canvas = canvasRef.current;

// if(!video || !canvas) return;

// const ctx = canvas.getContext("2d");

// canvas.width = video.videoWidth;
// canvas.height = video.videoHeight;

// ctx.drawImage(video,0,0);

// let src = cv.imread(canvas);
// let gray = new cv.Mat();
// let blur = new cv.Mat();
// let edges = new cv.Mat();
// let closed = new cv.Mat();

// cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);
// cv.GaussianBlur(gray, blur, new cv.Size(5, 5), 0);

// // ✅ edge detection
// cv.Canny(blur, edges, 50, 150);

// // ✅ FIX: close gaps in edges
// let kernel = cv.Mat.ones(5, 5, cv.CV_8U);
// cv.morphologyEx(edges, closed, cv.MORPH_CLOSE, kernel);
// kernel.delete();

// let contours = new cv.MatVector();
// let hierarchy = new cv.Mat();

// // ✅ FIX: use LIST instead of EXTERNAL
// cv.findContours(closed, contours, hierarchy, cv.RETR_LIST, cv.CHAIN_APPROX_SIMPLE);

// let biggest = null;
// let maxArea = 0;

// for (let i = 0; i < contours.size(); i++) {
//   let cnt = contours.get(i);
//   let area = cv.contourArea(cnt);

//   if (area < 1000) continue; // ignore noise

//   let peri = cv.arcLength(cnt, true);
//   let approx = new cv.Mat();

//   cv.approxPolyDP(cnt, approx, 0.02 * peri, true);

//   if (approx.rows === 4 && area > maxArea) {
//     biggest = approx;
//     maxArea = area;
//   } else {
//     approx.delete();
//   }
// }

// const videoArea = video.videoWidth * video.videoHeight;

// // ✅ FIX: reduce threshold (IMPORTANT)
// if (biggest && maxArea > 0.2 * videoArea) {

//   biggestContourRef.current = biggest;
//   setSheetDetected(true);

//   // draw corners
//   for (let i = 0; i < 4; i++) {
//     let point = biggest.intPtr(i);
//     ctx.beginPath();
//     ctx.arc(point[0], point[1], 6, 0, 2 * Math.PI);
//     ctx.fillStyle = "lime";
//     ctx.fill();
//   }

// } else {
//   setSheetDetected(false);
// }

// // 🧪 DEBUG (optional)
// // cv.imshow(canvasRef.current, closed);

// src.delete();
// gray.delete();
// blur.delete();
// edges.delete();
// closed.delete();
// contours.delete();
// hierarchy.delete();

// }, 400);

// return () => clearInterval(interval);

// }, [cameraReady, cvReady]);




//    const sortPoints = (pts) => {
//     pts = pts.sort((a, b) => a.y - b.y);

//     let top = pts.slice(0, 2).sort((a, b) => a.x - b.x);
//     let bottom = pts.slice(2, 4).sort((a, b) => a.x - b.x);

//     return [top[0], top[1], bottom[1], bottom[0]];
//   };

// const capture = async ()=>{

// if(!sheetDetected || !biggestContourRef.current){
// toast.error("Align the sheet properly");
// return;
// }

// // const imageSrc = webcamRef.current.getScreenshot();

// // const blob = await fetch(imageSrc).then(r=>r.blob());



// try{

// setLoading(true);

//    const canvas = canvasRef.current;
//       let src = cv.imread(canvas);
//       let dst = new cv.Mat();

//       let pts = [];

//       for (let i = 0; i < 4; i++) {
//         let p = biggestContourRef.current.intPtr(i);
//         pts.push({ x: p[0], y: p[1] });
//       }

//       let ordered = sortPoints(pts);

//       let srcTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         ordered[0].x, ordered[0].y,
//         ordered[1].x, ordered[1].y,
//         ordered[2].x, ordered[2].y,
//         ordered[3].x, ordered[3].y
//       ]);

//       let width = 800;
//       let height = 1200;

//       let dstTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         0, 0,
//         width, 0,
//         width, height,
//         0, height
//       ]);

//       let M = cv.getPerspectiveTransform(srcTri, dstTri);
//       cv.warpPerspective(src, dst, M, new cv.Size(width, height));

//       // show warped image
//       cv.imshow(canvasRef.current, dst);

//       const imageSrc = canvasRef.current.toDataURL("image/jpeg", 0.95);
//       const blob = await fetch(imageSrc).then(r => r.blob());

// const formData = new FormData();

// formData.append("image",blob,"omr.jpg");
// formData.append("exam_id",examId);
// formData.append("student_id",studentId);
// formData.append("class_id",classId);
// formData.append("questions",JSON.stringify(questions));
// formData.append("penalty",penalty);

// const res = await axios.post(
// "https://api.scannscore.com/scan_omr",
// formData
// );


// setLoading(false);

// onResult(res.data);
// if(res.status == 200){
// toast.success("OMR scanned successfully");
// } else if(res.status == 400){
// toast.success("OMR Already Scanned. Check Result.");
// }

//    src.delete();
//       dst.delete();
//       srcTri.delete();
//       dstTri.delete();
//       M.delete();


// }catch(err){

// setLoading(false);
// toast.error("Scan failed");

// }

// };

// return (

// <div style={{position:"relative"}}>

// <Webcam
// ref={webcamRef}
// audio={false}
// screenshotFormat="image/jpeg"
// screenshotQuality={0.95}
// forceScreenshotSourceSize={true}
// videoConstraints={{facingMode:"environment"}}
// onUserMedia={()=>setCameraReady(true)}
// style={{
// width:"100%",
// height:"500px",
// objectFit:"cover",
// borderRadius:"10px"
// }}
// />

// <canvas
// ref={canvasRef}
// style={{
// position:"absolute",
// top:0,
// left:0,
// width:"100%",
// height:"500px"
// }}
// />

// <button
// className="btn btn-success mt-3 w-100"
// disabled={!cameraReady || loading}
// onClick={capture}

// >

// {loading ? "Scanning..." : "Capture OMR"} </button>

// <button
// className="btn btn-secondary mt-3 w-100"
// onClick={()=>setSelectedExam("")}

// >

// Go Back </button>

// </div>

// );

// };

// export default OMRScanner;


// /* global cv */
// import React, { useEffect, useRef, useState } from "react";
// import Webcam from "react-webcam";
// import axios from "axios";
// import { toast } from "react-toastify";

// const OMRScanner = ({
//   examId,
//   questions,
//   studentId,
//   classId,
//   penalty,
//   setSelectedExam,
//   onResult
// }) => {

//   const webcamRef = useRef(null);
//   const overlayCanvasRef = useRef(null);

//   const [cameraReady, setCameraReady] = useState(false);
//   const [cvReady, setCvReady] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [sheetDetected, setSheetDetected] = useState(false);

//   const biggestContourRef = useRef(null);
//   const [autoCapture, setAutoCapture] = useState(false);
//   const stableCountRef = useRef(0);
//   const lastPointsRef = useRef(null);
//   const lastValidPointsRef = useRef(null);
// const autoCaptureRef = useRef(false);
// const capturingRef = useRef(false);

//   // -----------------------------
//   // LOAD OPENCV
//   // -----------------------------
//   useEffect(() => {
//     const check = setInterval(() => {
//       if (window.cv) {
//         setCvReady(true);
//         clearInterval(check);
//       }
//     }, 300);

//     return () => clearInterval(check);
//   }, []);

//   // -----------------------------
//   // SORT POINTS
//   // -----------------------------
//   const sortPoints = (pts) => {
//     const sorted = [...pts].sort((a, b) => a.y - b.y);
//     const top = sorted.slice(0, 2).sort((a, b) => a.x - b.x);
//     const bottom = sorted.slice(2, 4).sort((a, b) => a.x - b.x);
//     return [top[0], top[1], bottom[1], bottom[0]];
//   };


//   const isStable = (pts) => {
//   if (!lastPointsRef.current) {
//     lastPointsRef.current = pts;
//     return false;
//   }

//   let diff = 0;

//   for (let i = 0; i < 4; i++) {
//     diff += Math.abs(pts[i].x - lastPointsRef.current[i].x);
//     diff += Math.abs(pts[i].y - lastPointsRef.current[i].y);
//   }

//   lastPointsRef.current = pts;

//   return diff < 60;
// };

//   // -----------------------------
//   // LIVE DETECTION
//   // -----------------------------
//   useEffect(() => {
//     if (!cameraReady || !cvReady) return;

//     const interval = setInterval(() => {

//       const video = webcamRef.current.video;
//       const overlay = overlayCanvasRef.current;

//       if (!video || !overlay) return;

//       overlay.width = video.videoWidth;
//       overlay.height = video.videoHeight;

//       const ctx = overlay.getContext("2d");

//       // 🔥 CLEAR OLD DRAW
//       ctx.clearRect(0, 0, overlay.width, overlay.height);

//       // =============================
//       // FRAME CAPTURE
//       // =============================
//       const tempCanvas = document.createElement("canvas");
//       tempCanvas.width = video.videoWidth;
//       tempCanvas.height = video.videoHeight;
//       const tempCtx = tempCanvas.getContext("2d");
//       tempCtx.drawImage(video, 0, 0);

//       let src = cv.imread(tempCanvas);

//       // =============================
//       // GRAYSCALE + THRESHOLD
//       // =============================
//       let gray = new cv.Mat();
//       cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);

//       let blur = new cv.Mat();
//       cv.GaussianBlur(gray, blur, new cv.Size(5,5), 0);

//       let thresh = new cv.Mat();
//       cv.adaptiveThreshold(
//         blur,
//         thresh,
//         255,
//         cv.ADAPTIVE_THRESH_GAUSSIAN_C,
//         cv.THRESH_BINARY_INV,
//         31,
//         10
//       );

//       // =============================
//       // MORPH CLOSE
//       // =============================
//       let kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(7,7));
//       let close = new cv.Mat();
//       cv.morphologyEx(thresh, close, cv.MORPH_CLOSE, kernel);

//       // =============================
//       // CONTOURS
//       // =============================
//       let contours = new cv.MatVector();
//       let hierarchy = new cv.Mat();
//       cv.findContours(close, contours, hierarchy, cv.RETR_LIST, cv.CHAIN_APPROX_SIMPLE);

//       let candidates = [];
//       let imgArea = overlay.width * overlay.height;

//       for (let i = 0; i < contours.size(); i++) {
//         let cnt = contours.get(i);
//         let rect = cv.boundingRect(cnt);

//         let area = rect.width * rect.height;
//         let aspect = rect.width / rect.height;

//         // ✅ tuned marker detection
//         if (
//           area > imgArea * 0.0005 &&
//           area < imgArea * 0.02 &&
//           aspect > 0.7 && aspect < 1.3
//         ) {
//           candidates.push(rect);
//         }
//       }

//       console.log("Markers:", candidates.length);

//       const w = overlay.width;
//       const h = overlay.height;

//       const dist = (r, x, y) => {
//         let cx = r.x + r.width/2;
//         let cy = r.y + r.height/2;
//         return (cx-x)*(cx-x) + (cy-y)*(cy-y);
//       };

//       let markerPoints = [];

//       if (candidates.length >= 4) {

//         let tl = candidates.reduce((a,b)=> dist(a,0,0) < dist(b,0,0) ? a : b);
//         let tr = candidates.reduce((a,b)=> dist(a,w,0) < dist(b,w,0) ? a : b);
//         let br = candidates.reduce((a,b)=> dist(a,w,h) < dist(b,w,h) ? a : b);
//         let bl = candidates.reduce((a,b)=> dist(a,0,h) < dist(b,0,h) ? a : b);

//         markerPoints = [tl,tr,br,bl];
//       }

//       // =============================
//       // DRAW MARKERS
//       // =============================
//      if (markerPoints.length >= 4) {

//   setSheetDetected(true);

//   let pts = markerPoints.map(r => ({
//     x: r.x + r.width/2,
//     y: r.y + r.height/2
//   }));

//   // ✅ SORT POINTS (VERY IMPORTANT)
//   pts = sortPoints(pts);

//   let [p0, p1, p2, p3] = pts;

//   // =============================
//   // 🔥 OFFSET FIX (BORDER REMOVE)
//   // =============================
//   const offset = Math.floor(overlay.width * 0.01); // dynamic

//   const adjusted = [
//     { x: p0.x - offset, y: p0.y - offset }, // TL
//     { x: p1.x + offset, y: p1.y - offset }, // TR
//     { x: p2.x + offset, y: p2.y + offset }, // BR
//     { x: p3.x - offset, y: p3.y + offset }  // BL
//   ];

//   // =============================
//   // 🔥 DRAW BOX (USING ADJUSTED)
//   // =============================
//   ctx.strokeStyle = "lime";
//   ctx.lineWidth = 3;

//   // ctx.beginPath();
//   // ctx.moveTo(adjusted[0].x, adjusted[0].y);
//   // ctx.lineTo(adjusted[1].x, adjusted[1].y);
//   // ctx.lineTo(adjusted[2].x, adjusted[2].y);
//   // ctx.lineTo(adjusted[3].x, adjusted[3].y);
//   // ctx.closePath();
//   // ctx.stroke();

//   // 🔥 DRAW POINTS
//   adjusted.forEach(p=>{
//     ctx.beginPath();
//     ctx.arc(p.x, p.y, 8, 0, 2*Math.PI);
//     ctx.fillStyle = "lime";
//     ctx.fill();
//   });

//   // 🔥 SAVE ADJUSTED POINTS (IMPORTANT)
//   biggestContourRef.current = adjusted;
// lastValidPointsRef.current = adjusted;


//   if(isStable(adjusted)) {
//   stableCountRef.current++;
// } else {
//   stableCountRef.current = 0;   // RESET properly
// }


//   if (stableCountRef.current > 6 && !autoCaptureRef.current) {
//     ctx.fillStyle = "yellow";
//     ctx.font = "22px Arial";
//     ctx.fillText("Hold still...", 20, 40);
//   }

//   if (stableCountRef.current > 4) {
//     ctx.fillStyle = "lime";
//     ctx.font = "24px Arial";
//     ctx.fillText("Capturing...", 20, 80);
//   }

//   if(stableCountRef.current > 6 && !autoCapture && !capturingRef.current){
//     setSheetDetected(true);
//     capturingRef.current = true;
//     setAutoCapture(true);
//     setTimeout(() => {
//       capture();
//     }, 120);
//   }

// } else {
//   if (lastValidPointsRef.current) {
//   // 🔥 fallback use last detected markers
//   biggestContourRef.current = lastValidPointsRef.current;
//   setSheetDetected(true);

//   ctx.fillStyle = "yellow";
//   ctx.font = "20px Arial";
//   ctx.fillText("Hold steady...", 20, 40);

// } else {
//   setSheetDetected(false);

//   ctx.fillStyle = "red";
//   ctx.font = "20px Arial";
//   ctx.fillText("Align sheet inside frame", 20, 40);
// }
//         // setSheetDetected(false);
//         // stableCountRef.current = 0;
//         setAutoCapture(false);
//         autoCaptureRef.current = false;
//         // lastPointsRef.current = null;
//         // ctx.fillStyle = "red";
//         // ctx.font = "20px Arial";
//         // ctx.fillText("Align sheet inside frame", 20,40);
//       }

//       // =============================
//       // CLEANUP
//       // =============================
//       src.delete();
//       gray.delete();
//       blur.delete();
//       thresh.delete();
//       close.delete();
//       contours.delete();
//       hierarchy.delete();

//     }, 300);

//     return () => clearInterval(interval);

//   }, [cameraReady, cvReady]);

//   // -----------------------------
//   // CAPTURE
//   // -----------------------------
//   const capture = async () => {
//     const pts = biggestContourRef.current || lastValidPointsRef.current;

//     if (!pts) {
//       toast.error("Align sheet properly");
//       return;
//     }

//     try {
//       setLoading(true);

//       const video = webcamRef.current.video;

//       const canvas = document.createElement("canvas");
//       canvas.width = video.videoWidth;
//       canvas.height = video.videoHeight;

//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(video, 0, 0);

//       let src = cv.imread(canvas);
//       let dst = new cv.Mat();

//       const pts = biggestContourRef.current;

//       const srcTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         pts[0].x, pts[0].y,
//         pts[1].x, pts[1].y,
//         pts[2].x, pts[2].y,
//         pts[3].x, pts[3].y
//       ]);

//       const width = 900;
//       const height = 1300;

//       const dstTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         0,0,
//         width,0,
//         width,height,
//         0,height
//       ]);

//       const M = cv.getPerspectiveTransform(srcTri, dstTri);

//       cv.warpPerspective(
//         src,
//         dst,
//         M,
//         new cv.Size(width, height),
//         cv.INTER_LINEAR,
//         cv.BORDER_REPLICATE
//       );

//       const finalCanvas = document.createElement("canvas");
//       finalCanvas.width = width;
//       finalCanvas.height = height;

//       cv.imshow(finalCanvas, dst);

//       const blob = await new Promise(res =>
//         finalCanvas.toBlob(res, "image/jpeg", 0.95)
//       );

//       const formData = new FormData();
//       formData.append("image", blob, "omr.jpg");
//       formData.append("exam_id", examId);
//       formData.append("student_id", studentId);
//       formData.append("class_id", classId);
//       formData.append("questions", JSON.stringify(questions));
//       formData.append("penalty", penalty);

//       const res = await axios.post(
//         "https://api.scannscore.com/scan_omr",
//         formData
//       );

//       onResult(res.data);
//       toast.success("OMR scanned successfully");

//       src.delete();
//       dst.delete();
//       srcTri.delete();
//       dstTri.delete();
//       M.delete();

//     } catch (err) {
//       toast.error("Scan failed");
//     } finally {
//       setLoading(false);
//       stableCountRef.current = 0;
// autoCaptureRef.current = false;
// setAutoCapture(false);
// lastPointsRef.current = null;
// capturingRef.current = false;
//     }
//   };

//   // -----------------------------
//   // UI
//   // -----------------------------
//   return (
//     <div style={{ position: "relative" }}>

//       <Webcam
//         ref={webcamRef}
//         audio={false}
//         screenshotFormat="image/jpeg"
//         screenshotQuality={0.95}
//         forceScreenshotSourceSize={true}
//         videoConstraints={{ facingMode: "environment" }}
//         onUserMedia={() => setCameraReady(true)}
//         style={{
//           width: "100%",
//           height: "500px",
//           objectFit: "cover"
//         }}
//       />

//       <canvas
//         ref={overlayCanvasRef}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "500px"
//         }}
//       />

//       <button
//         className="btn btn-success mt-3 w-100"
//         disabled={!cameraReady || loading}
//         onClick={capture}
//       >
//         {loading ? "Scanning..." : "Capture OMR"}
//       </button>

//       <button
//         className="btn btn-secondary mt-3 w-100"
//         onClick={() => setSelectedExam("")}
//       >
//         Go Back
//       </button>

//     </div>
//   );
// };

// export default OMRScanner;


// wide lens issue sorted
/* global cv */
// import React, { useEffect, useRef, useState } from "react";
// import Webcam from "react-webcam";
// import axios from "axios";
// import { toast } from "react-toastify";

// const OMRScanner = ({
//   examId,
//   questions,
//   studentId,
//   classId,
//   penalty,
//   setSelectedExam,
//   onResult
// }) => {

//   const webcamRef = useRef(null);
//   const overlayCanvasRef = useRef(null);

//   const [cameraReady, setCameraReady] = useState(false);
//   const [cvReady, setCvReady] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [sheetDetected, setSheetDetected] = useState(false);

//   const biggestContourRef = useRef(null);
//   const [autoCapture, setAutoCapture] = useState(false);
//   const stableCountRef = useRef(0);
//   const lastPointsRef = useRef(null);
//   const lastValidPointsRef = useRef(null);
// const autoCaptureRef = useRef(false);
// const capturingRef = useRef(false);
// const [zoomLevel, setZoomLevel] = useState(1);

//   // -----------------------------
//   // LOAD OPENCV
//   // -----------------------------
//   useEffect(() => {
//     const check = setInterval(() => {
//       if (window.cv) {
//         setCvReady(true);
//         clearInterval(check);
//       }
//     }, 300);

//     return () => clearInterval(check);
//   }, []);

//   // -----------------------------
//   // SORT POINTS
//   // -----------------------------
//   const sortPoints = (pts) => {
//     const sorted = [...pts].sort((a, b) => a.y - b.y);
//     const top = sorted.slice(0, 2).sort((a, b) => a.x - b.x);
//     const bottom = sorted.slice(2, 4).sort((a, b) => a.x - b.x);
//     return [top[0], top[1], bottom[1], bottom[0]];
//   };


//   const isStable = (pts) => {
//   if (!lastPointsRef.current) {
//     lastPointsRef.current = pts;
//     return false;
//   }

//   let diff = 0;

//   for (let i = 0; i < 4; i++) {
//     diff += Math.abs(pts[i].x - lastPointsRef.current[i].x);
//     diff += Math.abs(pts[i].y - lastPointsRef.current[i].y);
//   }

//   lastPointsRef.current = pts;

//   return diff < 60;
// };

//   // -----------------------------
//   // LIVE DETECTION
//   // -----------------------------

// useEffect(() => {
//   const videoTrack = webcamRef.current?.stream?.getVideoTracks?.()[0];

//   if (!videoTrack) return;

//   const capabilities = videoTrack.getCapabilities?.();

//   if (capabilities?.zoom) {
//     videoTrack.applyConstraints({
//       advanced: [{ zoom: zoomLevel }]
//     });
//   }

// }, [zoomLevel]);


//   useEffect(() => {
//     if (!cameraReady || !cvReady) return;

//     const interval = setInterval(() => {

//       const video = webcamRef.current.video;
//       const overlay = overlayCanvasRef.current;

//       if (!video || !overlay) return;

//       overlay.width = video.videoWidth;
//       overlay.height = video.videoHeight;

//       const ctx = overlay.getContext("2d");

//       // 🔥 CLEAR OLD DRAW
//       ctx.clearRect(0, 0, overlay.width, overlay.height);

//       // =============================
//       // FRAME CAPTURE
//       // =============================
//       const tempCanvas = document.createElement("canvas");
//       tempCanvas.width = video.videoWidth;
//       tempCanvas.height = video.videoHeight;
//       const tempCtx = tempCanvas.getContext("2d");

// const zoom = zoomLevel;      // center crop based on zoom
// const cropW = video.videoWidth / zoom;
// const cropH = video.videoHeight / zoom;

// const cropX = (video.videoWidth - cropW) / 2;
// const cropY = (video.videoHeight - cropH) / 2;

// tempCtx.drawImage(
//   video,
//   cropX, cropY, cropW, cropH,
//   0, 0, tempCanvas.width, tempCanvas.height
// );

//       // tempCtx.drawImage(video, 0, 0);

//       let src = cv.imread(tempCanvas);

//       // =============================
//       // GRAYSCALE + THRESHOLD
//       // =============================
//       let gray = new cv.Mat();
//       cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);

//       let blur = new cv.Mat();
//       cv.GaussianBlur(gray, blur, new cv.Size(5,5), 0);

//       let thresh = new cv.Mat();
//       cv.adaptiveThreshold(
//         blur,
//         thresh,
//         255,
//         cv.ADAPTIVE_THRESH_GAUSSIAN_C,
//         cv.THRESH_BINARY_INV,
//         31,
//         10
//       );

//       // =============================
//       // MORPH CLOSE
//       // =============================
//       let kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(7,7));
//       let close = new cv.Mat();
//       cv.morphologyEx(thresh, close, cv.MORPH_CLOSE, kernel);

//       // =============================
//       // CONTOURS
//       // =============================
//       let contours = new cv.MatVector();
//       let hierarchy = new cv.Mat();
//       cv.findContours(close, contours, hierarchy, cv.RETR_LIST, cv.CHAIN_APPROX_SIMPLE);

//       let candidates = [];
//       let imgArea = overlay.width * overlay.height;

//       for (let i = 0; i < contours.size(); i++) {
//         let cnt = contours.get(i);
//         let rect = cv.boundingRect(cnt);

//         let area = rect.width * rect.height;
//         let aspect = rect.width / rect.height;

//         // ✅ tuned marker detection
//         if (
//           area > imgArea * 0.0005 &&
//           area < imgArea * 0.02 &&
//           aspect > 0.7 && aspect < 1.3
//         ) {
//           candidates.push(rect);
//         }
//       }


//       const w = overlay.width;
//       const h = overlay.height;

//       const dist = (r, x, y) => {
//         let cx = r.x + r.width/2;
//         let cy = r.y + r.height/2;
//         return (cx-x)*(cx-x) + (cy-y)*(cy-y);
//       };

//       let markerPoints = [];

//       if (candidates.length >= 4) {

//         let tl = candidates.reduce((a,b)=> dist(a,0,0) < dist(b,0,0) ? a : b);
//         let tr = candidates.reduce((a,b)=> dist(a,w,0) < dist(b,w,0) ? a : b);
//         let br = candidates.reduce((a,b)=> dist(a,w,h) < dist(b,w,h) ? a : b);
//         let bl = candidates.reduce((a,b)=> dist(a,0,h) < dist(b,0,h) ? a : b);

//         markerPoints = [tl,tr,br,bl];
//       }

//       // =============================
//       // DRAW MARKERS
//       // =============================
//      if (markerPoints.length >= 4) {

//   setSheetDetected(true);

//   let pts = markerPoints.map(r => ({
//     x: r.x + r.width/2,
//     y: r.y + r.height/2
//   }));

//   // ✅ SORT POINTS (VERY IMPORTANT)
//   pts = sortPoints(pts);

//   let [p0, p1, p2, p3] = pts;

//   // =============================
//   // 🔥 OFFSET FIX (BORDER REMOVE)
//   // =============================
//   const offset = Math.floor(overlay.width * 0.01); // dynamic

//   const adjusted = [
//     { x: p0.x - offset, y: p0.y - offset }, // TL
//     { x: p1.x + offset, y: p1.y - offset }, // TR
//     { x: p2.x + offset, y: p2.y + offset }, // BR
//     { x: p3.x - offset, y: p3.y + offset }  // BL
//   ];

//   // =============================
//   // 🔥 DRAW BOX (USING ADJUSTED)
//   // =============================
//   ctx.strokeStyle = "lime";
//   ctx.lineWidth = 3;

//   // ctx.beginPath();
//   // ctx.moveTo(adjusted[0].x, adjusted[0].y);
//   // ctx.lineTo(adjusted[1].x, adjusted[1].y);
//   // ctx.lineTo(adjusted[2].x, adjusted[2].y);
//   // ctx.lineTo(adjusted[3].x, adjusted[3].y);
//   // ctx.closePath();
//   // ctx.stroke();

//   // 🔥 DRAW POINTS
//   adjusted.forEach(p=>{
//     ctx.beginPath();
//     ctx.arc(p.x, p.y, 8, 0, 2*Math.PI);
//     ctx.fillStyle = "lime";
//     ctx.fill();
//   });

//   // 🔥 SAVE ADJUSTED POINTS (IMPORTANT)
//   biggestContourRef.current = adjusted;
// lastValidPointsRef.current = adjusted;


//   if(isStable(adjusted)) {
//   stableCountRef.current++;
// } else {
//   stableCountRef.current = 0;   // RESET properly
// }


//   if (stableCountRef.current > 6 && !autoCaptureRef.current) {
//     ctx.fillStyle = "yellow";
//     ctx.font = "22px Arial";
//     ctx.fillText("Hold still...", 20, 40);
//   }

//   if (stableCountRef.current > 4) {
//     ctx.fillStyle = "lime";
//     ctx.font = "bold 28px Arial";
//     ctx.fillText("Auto Capturing...", 20, 80);
//   }

//   if(stableCountRef.current > 6 && !autoCapture && !capturingRef.current){
//     setSheetDetected(true);
//     capturingRef.current = true;
//     setAutoCapture(true);
//     setTimeout(() => {
//       capture();
//     }, 120);
//   }

// } else {
//   if (lastValidPointsRef.current) {
//   // 🔥 fallback use last detected markers
//   biggestContourRef.current = lastValidPointsRef.current;
//   setSheetDetected(true);

//   ctx.fillStyle = "yellow";
//   ctx.font = "20px Arial";
//   ctx.fillText("Hold steady...", 20, 40);

// } else {
//   setSheetDetected(false);

//   ctx.fillStyle = "red";
//   ctx.font = "20px Arial";
//   ctx.fillText("Align sheet inside frame", 20, 40);
// }
//         // setSheetDetected(false);
//         // stableCountRef.current = 0;
//         setAutoCapture(false);
//         autoCaptureRef.current = false;
//         // lastPointsRef.current = null;
//         // ctx.fillStyle = "red";
//         // ctx.font = "20px Arial";
//         // ctx.fillText("Align sheet inside frame", 20,40);
//       }

//       // =============================
//       // CLEANUP
//       // =============================
//       src.delete();
//       gray.delete();
//       blur.delete();
//       thresh.delete();
//       close.delete();
//       contours.delete();
//       hierarchy.delete();

//     }, 300);

//     return () => clearInterval(interval);

//   }, [cameraReady, cvReady]);

//   // -----------------------------
//   // CAPTURE
//   // -----------------------------
//   const capture = async () => {
//     const pts = biggestContourRef.current || lastValidPointsRef.current;

//     if (!pts) {
//       toast.error("Align sheet properly");
//       return;
//     }

//     try {
//       setLoading(true);

//       const video = webcamRef.current.video;

//       const canvas = document.createElement("canvas");
//       canvas.width = video.videoWidth;
//       canvas.height = video.videoHeight;

//       const ctx = canvas.getContext("2d");

//       const zoom = zoomLevel;
//       // center crop based on zoom
// const cropW = video.videoWidth / zoom;
// const cropH = video.videoHeight / zoom;

// const cropX = (video.videoWidth - cropW) / 2;
// const cropY = (video.videoHeight - cropH) / 2;

// ctx.drawImage(
//   video,
//   cropX, cropY, cropW, cropH,
//   0, 0, canvas.width, canvas.height
// );
//       // ctx.drawImage(video, 0, 0);

//       let src = cv.imread(canvas);
//       let dst = new cv.Mat();

//       const pts = biggestContourRef.current;

//       const srcTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         pts[0].x, pts[0].y,
//         pts[1].x, pts[1].y,
//         pts[2].x, pts[2].y,
//         pts[3].x, pts[3].y
//       ]);

//       const width = 900;
//       const height = 1300;

//       const dstTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
//         0,0,
//         width,0,
//         width,height,
//         0,height
//       ]);

//       const M = cv.getPerspectiveTransform(srcTri, dstTri);

//       cv.warpPerspective(
//         src,
//         dst,
//         M,
//         new cv.Size(width, height),
//         cv.INTER_LINEAR,
//         cv.BORDER_REPLICATE
//       );

//       const finalCanvas = document.createElement("canvas");
//       finalCanvas.width = width;
//       finalCanvas.height = height;

//       cv.imshow(finalCanvas, dst);

//       const blob = await new Promise(res =>
//         finalCanvas.toBlob(res, "image/jpeg", 0.95)
//       );

//       const formData = new FormData();
//       formData.append("image", blob, "omr.jpg");
//       formData.append("exam_id", examId);
//       formData.append("student_id", studentId);
//       formData.append("class_id", classId);
//       formData.append("questions", JSON.stringify(questions));
//       formData.append("penalty", penalty);

//       const res = await axios.post(
//         "https://api.scannscore.com/scan_omr",
//         formData
//       );

//       onResult(res.data);
//       toast.success("OMR scanned successfully");

//       src.delete();
//       dst.delete();
//       srcTri.delete();
//       dstTri.delete();
//       M.delete();

//     } catch (err) {
//       toast.error("Scan failed");
//     } finally {
//       setLoading(false);
//       stableCountRef.current = 0;
// autoCaptureRef.current = false;
// setAutoCapture(false);
// lastPointsRef.current = null;
// capturingRef.current = false;
//     }
//   };

//   // -----------------------------
//   // UI
//   // -----------------------------
//   return (
//     <div style={{ position: "relative" }}>

// <div style={{
//   position: "absolute",
//   bottom: 110,
//   left: "50%",
//   transform: "translateX(-50%)",
//   zIndex: 10,
//   display: "flex",
//   gap: 10
// }}>
//   {[1, 1.5, 2].map(z => (
//     <button
//       key={z}
//       onClick={() => setZoomLevel(z)}
//       style={{
//         padding: "8px 12px",
//         borderRadius: "20px",
//         border: "none",
//         background: zoomLevel === z ? "lime" : "black",
//         color: "white",
//         fontWeight: "bold"
//       }}
//     >
//       {z}x
//     </button>
//   ))}
// </div>

//       <Webcam
//         ref={webcamRef}
//         audio={false}
//         screenshotFormat="image/jpeg"
//         screenshotQuality={0.95}
//         forceScreenshotSourceSize={true}
//         videoConstraints={{ facingMode: "environment" }}
//         onUserMedia={() => setCameraReady(true)}
//         style={{
//           width: "100%",
//           height: "500px",
//           objectFit: "cover"
//         }}
//       />

//       <canvas
//         ref={overlayCanvasRef}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "500px"
//         }}
//       />

//       <button
//         className="btn btn-success mt-3 w-100"
//         disabled={!cameraReady || loading}
//         onClick={capture}
//       >
//         {loading ? "Scanning..." : "Capture OMR"}
//       </button>

//       <button
//         className="btn btn-secondary mt-3 w-100"
//         onClick={() => setSelectedExam("")}
//       >
//         Go Back
//       </button>

//     </div>
//   );
// };

// export default OMRScanner;


// Final working CV
/* global cv */
import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.3)",
  backdropFilter: "blur(6px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const modal = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "400px",
        maxHeight: "95vh",
      overflowY: "auto",  
        scrollbarWidth: "none",  
    msOverflowStyle: "none",
            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
};


const OMRScanner = ({
  examId,
  questions,
  studentId,
  classId,
  penalty,
  setSelectedExam,
  onResult
}) => {

  const webcamRef = useRef(null);
  const overlayCanvasRef = useRef(null);

  const [cameraReady, setCameraReady] = useState(false);
  const [cvReady, setCvReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sheetDetected, setSheetDetected] = useState(false);

  const biggestContourRef = useRef(null);
  // const [autoCapture, setAutoCapture] = useState(false);
  const stableCountRef = useRef(0);
  const lastPointsRef = useRef(null);
  const lastValidPointsRef = useRef(null);
// const autoCaptureRef = useRef(false);
const capturingRef = useRef(false);
const [zoomLevel, setZoomLevel] = useState(1);
const [showIns, setShowIns] = useState(false);
const [enabled, setEnabled] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => {
    setEnabled(true);
  }, 5000);

  return () => clearTimeout(timer);
}, []);

  // -----------------------------
  // LOAD OPENCV
  // -----------------------------
  useEffect(() => {
    const check = setInterval(() => {
      if (window.cv) {
        setShowIns(true);
        setCvReady(true);
        clearInterval(check);
      }
    }, 300);

    return () => clearInterval(check);
  }, []);

  // -----------------------------
  // SORT POINTS
  // -----------------------------
  const sortPoints = (pts) => {
    const sorted = [...pts].sort((a, b) => a.y - b.y);
    const top = sorted.slice(0, 2).sort((a, b) => a.x - b.x);
    const bottom = sorted.slice(2, 4).sort((a, b) => a.x - b.x);
    return [top[0], top[1], bottom[1], bottom[0]];
  };


  const isStable = (pts) => {
  if (!lastPointsRef.current) {
    lastPointsRef.current = pts;
    return false;
  }

  let diff = 0;

  for (let i = 0; i < 4; i++) {
    diff += Math.abs(pts[i].x - lastPointsRef.current[i].x);
    diff += Math.abs(pts[i].y - lastPointsRef.current[i].y);
  }

  lastPointsRef.current = pts;

  return diff < 60;
};

// const isBlankSheet = (mat) => {
//   let gray = new cv.Mat();
//   let thresh = new cv.Mat();

//   cv.cvtColor(mat, gray, cv.COLOR_RGBA2GRAY);

//   cv.threshold(gray, thresh, 150, 255, cv.THRESH_BINARY_INV);

//   let nonZero = cv.countNonZero(thresh);
//   let total = mat.rows * mat.cols;

//   gray.delete();
//   thresh.delete();

//   let fillRatio = nonZero / total;

//   // 🔥 tweak this threshold
//   return fillRatio < 0.01; 
// };

const isTilted = (pts) => {

  const angle = (p1, p2) => {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;
  };

  // edges
  const top = angle(pts[0], pts[1]);
  const left = angle(pts[0], pts[3]);

  // normalize
  const topDiff = Math.abs(top);      
  const leftDiff = Math.abs(Math.abs(left) - 90);

  // 🔥 tolerance (adjustable)
  return topDiff > 3 || leftDiff > 3;
};


    const isBlurry = (src) => {
  let gray = new cv.Mat();
  let lap = new cv.Mat();
  let mean = new cv.Mat();
  let stddev = new cv.Mat();

  cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);
  cv.Laplacian(gray, lap, cv.CV_64F);

  cv.meanStdDev(lap, mean, stddev);

  let variance = Math.pow(stddev.doubleAt(0, 0), 2);

  gray.delete();
  lap.delete();
  mean.delete();
  stddev.delete();

  return variance < 100;
};


  // -----------------------------
  // LIVE DETECTION
  // -----------------------------

useEffect(() => {
  const videoTrack = webcamRef.current?.stream?.getVideoTracks?.()[0];

  if (!videoTrack) return;

  const capabilities = videoTrack.getCapabilities?.();

  if (capabilities?.zoom) {
    videoTrack.applyConstraints({
      advanced: [{ zoom: zoomLevel }]
    });
  }

}, [zoomLevel]);


const smoothPoints = (newPts) => {
  if (!lastPointsRef.current) {
    lastPointsRef.current = newPts;
    return newPts;
  }

  const smoothed = newPts.map((p, i) => ({
    x: lastPointsRef.current[i].x * 0.7 + p.x * 0.3,
    y: lastPointsRef.current[i].y * 0.7 + p.y * 0.3
  }));

  lastPointsRef.current = smoothed;
  return smoothed;
};




  useEffect(() => {
    if (!cameraReady || !cvReady) return;

    const interval = setInterval(() => {

      const video = webcamRef.current.video;
      const overlay = overlayCanvasRef.current;

      if (!video || !overlay) return;

      overlay.width = video.videoWidth;
      overlay.height = video.videoHeight;

      const ctx = overlay.getContext("2d");

      // 🔥 CLEAR OLD DRAW
      ctx.clearRect(0, 0, overlay.width, overlay.height);

      // =============================
      // FRAME CAPTURE
      // =============================
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = video.videoWidth;
      tempCanvas.height = video.videoHeight;
      const tempCtx = tempCanvas.getContext("2d");

const zoom = zoomLevel;      // center crop based on zoom
const cropW = video.videoWidth / zoom;
const cropH = video.videoHeight / zoom;

const cropX = (video.videoWidth - cropW) / 2;
const cropY = (video.videoHeight - cropH) / 2;

// tempCtx.drawImage(
//   video,
//   cropX, cropY, cropW, cropH,
//   0, 0, tempCanvas.width, tempCanvas.height
// );

      tempCtx.drawImage(video, 0, 0);

      let src = cv.imread(tempCanvas);

       if(isBlurry(src)){
        ctx.fillStyle = "orange";
        ctx.font = "22px Arial";
        ctx.fillText("Image Blurry", 20, 80);
      }
      // =============================
      // GRAYSCALE + THRESHOLD
      // =============================
      let gray = new cv.Mat();
      cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);

      let blur = new cv.Mat();
      cv.GaussianBlur(gray, blur, new cv.Size(5,5), 0);

      let thresh = new cv.Mat();
      cv.adaptiveThreshold(
        blur,
        thresh,
        255,
        cv.ADAPTIVE_THRESH_GAUSSIAN_C,
        cv.THRESH_BINARY_INV,
        31,
        10
      );

      // =============================
      // MORPH CLOSE
      // =============================
      let kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(7,7));
      let close = new cv.Mat();
      cv.morphologyEx(thresh, close, cv.MORPH_CLOSE, kernel);

      // =============================
      // CONTOURS
      // =============================
      let contours = new cv.MatVector();
      let hierarchy = new cv.Mat();
      cv.findContours(close, contours, hierarchy, cv.RETR_LIST, cv.CHAIN_APPROX_SIMPLE);

      let candidates = [];
      let imgArea = overlay.width * overlay.height;

      for (let i = 0; i < contours.size(); i++) {
        let cnt = contours.get(i);
        let rect = cv.boundingRect(cnt);

        let area = rect.width * rect.height;
        let aspect = rect.width / rect.height;

        // ✅ tuned marker detection
        if (
          area > imgArea * 0.0005 &&
          area < imgArea * 0.02 &&
          aspect > 0.7 && aspect < 1.3
        ) {
          candidates.push(rect); 
        }
      }


      const w = overlay.width;
      const h = overlay.height;

      const dist = (r, x, y) => {
        let cx = r.x + r.width/2;
        let cy = r.y + r.height/2;
        return (cx-x)*(cx-x) + (cy-y)*(cy-y);
      };

      let markerPoints = [];

      if (candidates.length >= 4) {

        let tl = candidates.reduce((a,b)=> dist(a,0,0) < dist(b,0,0) ? a : b);
        let tr = candidates.reduce((a,b)=> dist(a,w,0) < dist(b,w,0) ? a : b);
        let br = candidates.reduce((a,b)=> dist(a,w,h) < dist(b,w,h) ? a : b);
        let bl = candidates.reduce((a,b)=> dist(a,0,h) < dist(b,0,h) ? a : b);

        markerPoints = [tl,tr,br,bl];
      }

      // =============================
      // DRAW MARKERS
      // =============================
     if (markerPoints.length >= 4) {

  setSheetDetected(true);

  let pts = markerPoints.map(r => ({
    x: r.x + r.width/2,
    y: r.y + r.height/2
  }));

  // ✅ SORT POINTS (VERY IMPORTANT)
  pts = sortPoints(pts);
    pts = smoothPoints(pts);

  if (isTilted(pts)) {

  ctx.fillStyle = "red";
  ctx.font = "20px Arial";
  ctx.fillText("Straighten sheet", 20, 40);
  return;
}

    if (isStable(pts)) {
  ctx.fillStyle = "yellow";
  ctx.font = "18px Arial";
  ctx.fillText("Hold steady...", 20, 40);
}



  let [p0, p1, p2, p3] = pts;

  // =============================
  // 🔥 OFFSET FIX (BORDER REMOVE)
  // =============================
  const offset = Math.floor(overlay.width * 0.01); // dynamic

  const adjusted = [
    { x: p0.x - offset, y: p0.y - offset }, // TL
    { x: p1.x + offset, y: p1.y - offset }, // TR
    { x: p2.x + offset, y: p2.y + offset }, // BR
    { x: p3.x - offset, y: p3.y + offset }  // BL
  ];

  // =============================
  // 🔥 DRAW BOX (USING ADJUSTED)
  // =============================
  ctx.strokeStyle = "lime";
  ctx.lineWidth = 3;

  // ctx.beginPath();
  // ctx.moveTo(adjusted[0].x, adjusted[0].y);
  // ctx.lineTo(adjusted[1].x, adjusted[1].y);
  // ctx.lineTo(adjusted[2].x, adjusted[2].y);
  // ctx.lineTo(adjusted[3].x, adjusted[3].y);
  // ctx.closePath();
  // ctx.stroke();

  // 🔥 DRAW POINTS
  adjusted.forEach(p=>{
    ctx.beginPath();
    ctx.arc(p.x, p.y, 8, 0, 2*Math.PI);
    ctx.fillStyle = "lime";
    ctx.fill();
  });

  // 🔥 SAVE ADJUSTED POINTS (IMPORTANT)
  biggestContourRef.current = adjusted;
lastValidPointsRef.current = adjusted;


  if(isStable(adjusted)) {
  stableCountRef.current++;
} else {
  stableCountRef.current = 0;   // RESET properly
}



  // if (stableCountRef.current > 6 && !autoCaptureRef.current) {
  //   ctx.fillStyle = "yellow";
  //   ctx.font = "22px Arial";
  //   ctx.fillText("Hold still...", 20, 40);
  // }

  // if (stableCountRef.current > 4) {
  //   ctx.fillStyle = "lime";
  //   ctx.font = "bold 28px Arial";
  //   ctx.fillText("Auto Capturing...", 20, 80);
  // }

  // if(stableCountRef.current > 6 && !autoCapture && !capturingRef.current){
  //   setSheetDetected(true);
  //   capturingRef.current = true;
  //   setAutoCapture(true);
  //   setTimeout(() => {
  //     capture();
  //   }, 120);
  // }

} else {
  if (lastValidPointsRef.current) {
  // 🔥 fallback use last detected markers
  biggestContourRef.current = lastValidPointsRef.current;
  setSheetDetected(true);

  ctx.fillStyle = "yellow";
  ctx.font = "20px Arial";
  ctx.fillText("Hold steady...", 20, 40);

} else {
  setSheetDetected(false);

  ctx.fillStyle = "red";
  ctx.font = "20px Arial";
  ctx.fillText("Align sheet inside frame", 20, 40);
}
        // setSheetDetected(false);
        // stableCountRef.current = 0;
        // setAutoCapture(false);
        // autoCaptureRef.current = false;
        // lastPointsRef.current = null;
        // ctx.fillStyle = "red";
        // ctx.font = "20px Arial";
        // ctx.fillText("Align sheet inside frame", 20,40);
      }

      // =============================
      // CLEANUP
      // =============================
      src.delete();
      gray.delete();
      blur.delete();
      thresh.delete();
      close.delete();
      contours.delete();
      hierarchy.delete();

    }, 300);

    return () => clearInterval(interval);

  }, [cameraReady, cvReady]);

  // -----------------------------
  // CAPTURE
  // -----------------------------
  const capture = async () => {
    const pts = biggestContourRef.current || lastValidPointsRef.current;

    if (!pts) {
      toast.error("Align sheet properly");
      return;
    }

    try {
      setLoading(true);

      const video = webcamRef.current.video;

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext("2d");

      const zoom = zoomLevel;
      // center crop based on zoom
const cropW = video.videoWidth / zoom;
const cropH = video.videoHeight / zoom;

const cropX = (video.videoWidth - cropW) / 2;
const cropY = (video.videoHeight - cropH) / 2;

// ctx.drawImage(
//   video,
//   cropX, cropY, cropW, cropH,
//   0, 0, canvas.width, canvas.height
// );
      ctx.drawImage(video, 0, 0);

      let src = cv.imread(canvas);
      let dst = new cv.Mat();

      const pts = biggestContourRef.current;

      const srcTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
        pts[0].x, pts[0].y,
        pts[1].x, pts[1].y,
        pts[2].x, pts[2].y,
        pts[3].x, pts[3].y
      ]);

      const width = 900;
      const height = 1300;

      const dstTri = cv.matFromArray(4, 1, cv.CV_32FC2, [
        0,0,
        width,0,
        width,height,
        0,height
      ]);

      const M = cv.getPerspectiveTransform(srcTri, dstTri);

      cv.warpPerspective(
        src,
        dst,
        M,
        new cv.Size(width, height),
        cv.INTER_LINEAR,
        cv.BORDER_REPLICATE
      );

  //     if (isBlankSheet(dst)) {
  // toast.error("Blank sheet detected ❌");
  
//   src.delete();
//   dst.delete();
//   srcTri.delete();
//   dstTri.delete();
//   M.delete();

//   setLoading(false);
//   return;
// }
      const finalCanvas = document.createElement("canvas");
      finalCanvas.width = width;
      finalCanvas.height = height;

      cv.imshow(finalCanvas, dst);

      const blob = await new Promise(res =>
        finalCanvas.toBlob(res, "image/jpeg", 0.95)
      );

      const formData = new FormData();
      formData.append("image", blob, "omr.jpg");
      formData.append("exam_id", examId);
      formData.append("student_id", studentId);
      formData.append("class_id", classId);
      formData.append("questions", JSON.stringify(questions));
      formData.append("penalty", penalty);

      const res = await axios.post(
        "https://api.scannscore.com/scan_omr",
        formData
      );

      onResult(res.data);
      toast.success("OMR scanned successfully");

      src.delete();
      dst.delete(); 
      srcTri.delete();
      dstTri.delete();
      M.delete();

    } catch (err) {
      toast.error("Scan failed");
    } finally {
      setLoading(false);
      stableCountRef.current = 0;
// autoCaptureRef.current = false;
// setAutoCapture(false);
lastPointsRef.current = null;
capturingRef.current = false;
    }
  };

  // -----------------------------
  // UI
  // -----------------------------
  return (
    <>
    <div style={{ position: "relative" }}>

<div style={{
  position: "absolute",
  bottom: 110,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 10,
  display: "flex",
  gap: 10
}}>
  {[1, 1.5, 2].map(z => (
    <button
      key={z}
      onClick={() => setZoomLevel(z)}
      style={{
        padding: "8px 12px",
        borderRadius: "20px",
        border: "none",
        background: zoomLevel === z ? "lime" : "black",
        color: "white",
        fontWeight: "bold"
      }}
    >
      {z}x
    </button>
  ))}
</div>

      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        screenshotQuality={0.95}
        forceScreenshotSourceSize={true}
        videoConstraints={{ facingMode: "environment" }}
        onUserMedia={() => setCameraReady(true)}
        style={{
          width: "100%",
          height: "500px",
          objectFit: "cover"
        }}
      />

      <canvas
        ref={overlayCanvasRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "500px"
        }}
      />

      <button
        className="btn btn-success mt-3 w-100"
        disabled={!cameraReady || loading || !sheetDetected}
        onClick={capture}
      >
         {!sheetDetected ? "Align Sheet Markers" : loading ? "Scanning..." : "Capture OMR"}
      </button>

      <button
        className="btn btn-secondary mt-3 w-100"
        onClick={() => setSelectedExam("")}
      >
        Go Back
      </button>

    </div>


{showIns &&
    <div style={overlay}>
      <div style={modal}>


          <h5 className="text-center" style={{color: '#610000'}}>READ CAREFULLY</h5>

<p className="fw-bold mt-3">मोबाइल से OMR स्कैनिंग प्रक्रिया:</p>

<b style={{color: '#610000'}}>1. लाइटिंग (Lighting):</b><br />
<p className="fw-semibold">तेज़ और समान रोशनी का उपयोग करें ताकि कोई छाया (shadow) न बने। सीधे सूरज की रोशनी से बचें क्योंकि इससे चमक (glare) आती है और कैमरा कन्फ्यूज़ हो सकता है।</p>

<b style={{color: '#610000'}}>2. सतह (Surface):</b>
<p className="fw-semibold">OMR शीट को एक समतल, सख्त और कंट्रास्ट वाली सतह पर रखें (जैसे सफेद शीट को काले टेबल पर रखें)।</p>

<b style={{color: '#610000'}}>3. कैमरा पोज़िशन (Camera Position):</b>
<p className="fw-semibold">फोन को शीट के ठीक ऊपर रखें और ध्यान दें कि कैमरा पेपर के बिल्कुल समानांतर (parallel) हो।</p>

<b style={{color: '#610000'}}>4. एलाइनमेंट (Alignment):</b>
<p className="fw-semibold">शीट टेढ़ी या झुकी हुई नहीं होनी चाहिए। चारों कोनों पर बने काले मार्कर कैमरे में साफ दिखने चाहिए।</p>

<b style={{color: '#610000'}}>5. कैप्चर (Capture):</b>
<p className="fw-semibold">स्कैनर ऐप अपने आप शीट को डिटेक्ट कर लेगा और बबल्स (bubble markings) को पहचानकर तुरंत रिज़ल्ट प्रोसेस कर देगा।</p>

 <button
 
        className="btn btn-dark mt-3 w-100"
        style={{background: '#610000'}}
     onClick={() => 
  setShowIns(false)
}
 disabled={!enabled}
      >
        {enabled ? "OK. I UNDERSTAND" : "Read Properly..."}
      </button>

        </div>
        </div>
        }
</>

  );
};

export default OMRScanner;


